/* NW sengeguide: mobiljustering af bundbjaelken. 31-08-2026.

   HISTORIK: filen gav foerst titlen to linjer paa mobil. Det loeste ét problem og
   skabte to: bjaelken voksede naar kunden tilfoejede et tilvalg, saa layoutet hoppede
   under fingeren, og metalinjen blev klippet saa besparelsen stod som "du sparer ...".
   Den loesning er droppet. nw-sg-bar.js skriver nu titlen uden materialenavnet paa
   smalle skaerme og har reserveret hoejde paa metalinjen, saa bjaelken er lige hoej
   uanset hvad der er valgt.

   TILBAGE ER KUN AT FINDE DE SIDSTE PIXEL. "Lys beige . 140x200" klippede stadig med
   et par pixel i venstre kolonne, som kun er cirka 89 px paa en 375 px skaerm. Vi
   henter pladsen tre steder: mindre foto, mindre mellemrum og en anelse mindre skrift.
   Ingen af delene aendrer bjaelkens hoejde.

   Ligger her og ikke i nw-sg-bar.js, fordi det er ren finjustering af mobil og skal
   kunne skrues paa eller fjernes uden at roere logikken. Filen indlaeses EFTER
   nw-sg-bar.js, saa reglerne herunder vinder ved samme specificitet. */
(function(){
  'use strict';

  function stil(){
    var gl = document.getElementById('nw-sg-bar2-css');
    if(gl){ gl.parentNode.removeChild(gl); }
    var s = document.createElement('style');
    s.id = 'nw-sg-bar2-css';
    s.textContent =
      '@media(max-width:620px){' +
        '#nwsg .bar .bleft{gap:9px}' +
        '#nwsg .bar .bthumb{width:34px;height:34px}' +
        '#nwsg .bar .bleft .binfo .bt{font-size:11px;letter-spacing:-0.1px}' +
        '#nwsg .bar .bleft .binfo .bmeta{font-size:10.5px}' +
        '#nwsg .bar .wrap{gap:8px}' +
      '}';
    document.head.appendChild(s);
  }

  stil();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', stil); }
  window.addEventListener('load', stil);
  setTimeout(stil, 2000);
})();